<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Follow Up Boss</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <b-row align-v="center" slot="header">
            <b-col>
              <h3 class="mb-0">Incomplete Deals</h3>
            </b-col>
            <b-col class="text-right">
              <b-button variant="danger" v-b-modal.fub-integration>{{ integration.id ? 'Edit Integration' : 'Setup Integration'}}</b-button>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <div v-if="transactions.length > 0">
            <p class="small"><em>Please review and complete any outstanding information for each transaction. <br><span class="text-danger">Note: If you haven't filled out any of the Custom ClarityNOW fields they will be defaulted when transferred and you will have to update those values as well.</span></em></p>
          </div>
          <div class="text-center" v-else>
            <strong>You currently do not have any incomplete transactions.</strong>
          </div>
        </b-card-body>
        <b-table responsive id="transactions" small :items="transactions" :fields="columns" v-if="transactions.length > 0">
          <template #cell(actions)="row">
            <b-dropdown variant="info" size="sm" id="deal-actions" text="Actions">
              <b-dropdown-item variant="info" @click="handleEdit(row)"><i class="fa fa-edit"></i> Edit</b-dropdown-item>
              <b-dropdown-item variant="info" v-b-toggle.deal-sidebar @click="dealId = row.item.deal_id" v-if="row.item.deal_id"><img src="/img/fub/fub-icon.png" class="mr-3" /> FUB Deal</b-dropdown-item>
            </b-dropdown>
          </template>
          <template #cell(status)="row">
            <b-badge :variant="variants[row.item.status]">{{ row.item.status }}</b-badge>
          </template>
          <template #cell(units)="row">
            <span v-if="row.item.units == true">Yes</span>
            <span v-else>No</span>
          </template>
          <template #cell(listing_price)="row">
            {{ row.item.listing_price | currency }}
          </template>
          <template #cell(sale_price)="row">
            {{ row.item.sale_price | currency }}
          </template>
          <template #cell(gross_commission)="row">
            {{ row.item.gross_commission | currency }}
          </template>
          <template #cell(net_commission)="row">
            {{ row.item.net_commission | currency }}
          </template>
        </b-table>
      </b-card>
    </b-container>
    <fub-integration :userRoute="userRoute" :integration="integration" @getIntegration="getIntegration"></fub-integration>
    <deal :dealId="dealId"></deal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import FubIntegration from '@/views/Components/Modals/FubIntegration';
import errorsMixin from '@/mixins/errors-mixin';
import columns from './incompleteColumns';
import Deal from '@/views/Components/FUB/Deal';

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb,
    FubIntegration,
    Deal
  },
  data() {
    return {
      deals: [],
      dealId: null,
      columns: columns,
      transactions: [],
      integration: {
          id: null,
          name: 'follow-up-boss',
          api_key: null,
          masked_key: null,
          completed: false
      },
      variants: {
        'coming-soon': 'info',
        active: 'success',
        pending: 'info',
        closed: 'success'
      },
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
    }),
  },
  methods: {
    async getIntegration() {
      await axios.get(this.userRoute + "/integrations?type=follow-up-boss")
      .then(response => {
        if(Object.keys(response.data).length > 0) {
          this.integration.id = response.data.id;
          this.integration.api_key = response.data.api_key;
          this.integration.masked_key = "*********" + response.data.api_key.substring(response.data.api_key.length - 4);
          this.integration.completed = response.data.completed;
        }
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getIncomplete() {
      await axios.get(this.userRoute + "/integrations/fub/incomplete")
      .then(response => {
        this.transactions = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async storeDeals() {
      await axios.post(this.userRoute + "/integrations/fub/transfer", {
        deals: this.$route.query.deals.split(",")
      })
      .then(response => {
        this.$router.push("/integrations/follow-up-boss");
      })
      .catch(error => {
        this.error(error);
      });
    },
    handleEdit(row) {
      const path = '/transactions/' + row.item.id;
      this.$router.push({
        path: path,
      });
    },
  },
  created() {
    this.$route.query
    this.getIntegration();
    this.getIncomplete();
  }
};
</script>